document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        document.body.style.visibility = 'visible';
        
        var wrappers = document.querySelectorAll('.ae-content-wrapper');
        wrappers.forEach(function(wrapper) {
            wrapper.style.visibility = 'visible';
        });
    }, 1500);
});
